import React from "react";
import { Link } from "react-router-dom";
import "./Product.scss";
import { pathMaker } from "../../../../utils/helperFunctions";
import { addCommas } from "@persian-tools/persian-tools";
import ekia from "../../../../assets/images/ekia.png";

const Product = ({ item, active }) => {
  const timestamp = Date.now();
  return (
    <Link
      to={`/product/${item.id}`}
      className="product-result d-flex flex-column h-100"
      style={{ cursor: "pointer" }}
      onClick={(e) => active(false)}
    >
      <div className="product-result-photo">
        <img
          src={item.file === "" ? ekia : pathMaker(item.file)}
          alt={item.title}
        />
      </div>
      <div className="product-result-title font-14-500">{item.title}</div>
      <div className="product-result-prices mt-auto">
        {+item.max_discount !== 0 ? (
          <span className="product-result-base-price">
            {addCommas(+item.min_price + +item.max_discount)} تومان
          </span>
        ) : (
          ""
        )}

        <span className="product-result-discounted-price">
          {+item.max_discount_tm !== 0 && item.max_discount_tm !== ""
            ? timestamp > +item.max_discount_tm
              ? addCommas(item.min_price)
              : addCommas(item.min_price)
            : addCommas(item.min_price)}{" "}
          تومان
        </span>
      </div>
    </Link>
  );
};

export default Product;
